import { render, staticRenderFns } from "./ImportOrderModal.vue?vue&type=template&id=edea257c&"
import script from "./ImportOrderModal.vue?vue&type=script&lang=js&"
export * from "./ImportOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports